import executer from './executer';

type DebounceCallback = () => unknown;

const debounce = (callback: DebounceCallback, wait: number, immediate?: boolean): (() => void) => {
  let timeout: ReturnType<typeof setTimeout> | null | undefined;

  return () => {
    clearTimeout(timeout ?? undefined);
    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) executer(callback);
    }, wait);
    if (immediate && !timeout) executer(callback);
  };
};

export default debounce;
